import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import BootstrapVue from 'bootstrap-vue';
import VueDragula from 'vue-dragula'

require('es6-promise').polyfill();

Vue.use(BootstrapVue);
//axios.defaults.withCredentials = true;
Vue.prototype.$http = axios;
Vue.prototype.$http.defaults.withCredentials = true;
Vue.component('datepicker', Datepicker);
Vue.use(VueDragula, {
  logging: {
    service: true // to only log methods in service (DragulaService)
  }
});
console.info("©CARROT Global Inc.");
new Vue({
  el: '#vue_app',
  data: vue_data,
  methods: vue_methods,
  mounted: vue_mounted
});




// WEBPACK FOOTER //
// ./src/main.js